import React, { useState, useEffect } from 'react';

const ChairmanDashboard = ({ onModuleChange }) => {
  const [overview, setOverview] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch('/api/chairman/overview', {
      headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` }
    })
      .then(r => r.json())
      .then(d => { setOverview(d); setLoading(false); })
      .catch(() => setLoading(false));
  }, []);

  if (loading) return <div style={{padding:'40px',color:'#94a3b8',textAlign:'center'}}>Loading Chairman Dashboard...</div>;

  return (
    <div style={{padding:'24px'}}>
      <div style={{marginBottom:'32px'}}>
        <h1 style={{color:'#e2e8f0',margin:0,fontSize:'28px'}}>👑 Chairman Dashboard</h1>
        <p style={{color:'#64748b',margin:'8px 0 0',fontSize:'14px'}}>Global overview across all Aetheris instances</p>
      </div>

      {/* Top metrics */}
      <div style={{display:'grid',gridTemplateColumns:'repeat(3,1fr)',gap:'16px',marginBottom:'32px'}}>
        <div style={{background:'linear-gradient(135deg,#1e293b,#0f172a)',borderRadius:'16px',padding:'24px',border:'1px solid #334155',cursor:'pointer'}}
          onClick={() => onModuleChange('tenant-registry')}>
          <div style={{color:'#64748b',fontSize:'12px',letterSpacing:'1px',marginBottom:'12px'}}>TOTAL TENANTS</div>
          <div style={{color:'#7c3aed',fontSize:'40px',fontWeight:'bold'}}>{overview?.totalTenants || 0}</div>
          <div style={{color:'#64748b',fontSize:'12px',marginTop:'8px'}}>→ View Registry</div>
        </div>
        <div style={{background:'linear-gradient(135deg,#1e293b,#0f172a)',borderRadius:'16px',padding:'24px',border:'1px solid #334155'}}>
          <div style={{color:'#64748b',fontSize:'12px',letterSpacing:'1px',marginBottom:'12px'}}>TOTAL EMPLOYEES</div>
          <div style={{color:'#34d399',fontSize:'40px',fontWeight:'bold'}}>{overview?.totalEmployees || 0}</div>
          <div style={{color:'#64748b',fontSize:'12px',marginTop:'8px'}}>Across all tenants</div>
        </div>
        <div style={{background:'linear-gradient(135deg,#1e293b,#0f172a)',borderRadius:'16px',padding:'24px',border:'1px solid #334155'}}>
          <div style={{color:'#64748b',fontSize:'12px',letterSpacing:'1px',marginBottom:'12px'}}>TOTAL CLIENTS</div>
          <div style={{color:'#3b82f6',fontSize:'40px',fontWeight:'bold'}}>{overview?.totalClients || 0}</div>
          <div style={{color:'#64748b',fontSize:'12px',marginTop:'8px'}}>Across all tenants</div>
        </div>
      </div>

      {/* Tenant cards */}
      <h2 style={{color:'#e2e8f0',marginBottom:'16px',fontSize:'18px'}}>🏢 Active Instances</h2>
      <div style={{display:'grid',gridTemplateColumns:'repeat(auto-fill,minmax(300px,1fr))',gap:'16px'}}>
        {overview?.tenants?.map(t => (
          <div key={t.businessId} style={{
            background:'#1e293b',borderRadius:'12px',padding:'20px',
            border:'1px solid #334155'
          }}>
            <div style={{display:'flex',justifyContent:'space-between',alignItems:'flex-start',marginBottom:'16px'}}>
              <h3 style={{color:'#e2e8f0',margin:0,fontSize:'15px'}}>{t.name}</h3>
              <span style={{
                padding:'3px 10px',borderRadius:'20px',fontSize:'11px',
                background: t.error ? '#4b1113' : '#064e3b',
                color: t.error ? '#f87171' : '#34d399'
              }}>{t.error ? 'error' : 'active'}</span>
            </div>
            <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:'12px',marginBottom:'16px'}}>
              <div style={{background:'#0f172a',borderRadius:'8px',padding:'12px',textAlign:'center'}}>
                <div style={{color:'#34d399',fontSize:'24px',fontWeight:'bold'}}>{t.employees}</div>
                <div style={{color:'#64748b',fontSize:'11px'}}>employees</div>
              </div>
              <div style={{background:'#0f172a',borderRadius:'8px',padding:'12px',textAlign:'center'}}>
                <div style={{color:'#3b82f6',fontSize:'24px',fontWeight:'bold'}}>{t.clients}</div>
                <div style={{color:'#64748b',fontSize:'11px'}}>clients</div>
              </div>
            </div>
            {t.url && (
              <a href={t.url} target="_blank" rel="noreferrer" style={{
                display:'block',textAlign:'center',background:'rgba(124,58,237,0.1)',
                color:'#7c3aed',padding:'8px',borderRadius:'8px',
                textDecoration:'none',fontSize:'13px',border:'1px solid rgba(124,58,237,0.3)'
              }}>🚀 Open Instance</a>
            )}
          </div>
        ))}
      </div>

      {/* Quick actions */}
      <h2 style={{color:'#e2e8f0',margin:'32px 0 16px',fontSize:'18px'}}>⚡ Quick Actions</h2>
      <div style={{display:'grid',gridTemplateColumns:'repeat(3,1fr)',gap:'12px'}}>
        {[
          {label:'Add Tenant', icon:'➕', module:'tenant-registry'},
          {label:'Global Analytics', icon:'📊', module:'global-analytics'},
          {label:'Update Control', icon:'🚀', module:'update-control'},
          {label:'Knowledge Layer', icon:'🧠', module:'knowledge-layer'},
          {label:'Chairman Team', icon:'👥', module:'team'},
        ].map(a => (
          <button key={a.module} onClick={() => onModuleChange(a.module)} style={{
            background:'#1e293b',border:'1px solid #334155',borderRadius:'12px',
            padding:'16px',color:'#e2e8f0',cursor:'pointer',fontSize:'14px',
            display:'flex',alignItems:'center',gap:'10px'
          }}>
            <span style={{fontSize:'20px'}}>{a.icon}</span>
            {a.label}
          </button>
        ))}
      </div>
    </div>
  );
};

export default ChairmanDashboard;
